'use strict';

var $ = require('jquery');
var formHelpers = require('../checkout/formErrors');

module.exports = function () {
    var $form = $('#track-order');
    if (!$form.length) return;

    $form.on('submit', function (e) {
        e.preventDefault();

        if (formHelpers.clearPreviousErrors) {
            formHelpers.clearPreviousErrors($form);
        }

        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            data: $form.serialize(),
            success(data) {
                // update CSRF token in the form (important: no reload)
                if (data && data.csrf && data.csrf.tokenName && data.csrf.token) {
                    $form.find(`input[name="${data.csrf.tokenName}"]`).val(data.csrf.token);
                }

                if (data && data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                    return;
                }

                if (data && data.fieldErrors) {
                    formHelpers.loadFormErrors($form, data.fieldErrors);
                }
            },
            error(err) {
                var json = err && err.responseJSON;

                if (json && json.csrf && json.csrf.tokenName && json.csrf.token) {
                    $form.find(`input[name="${json.csrf.tokenName}"]`).val(json.csrf.token);
                }

                if (json && json.fieldErrors) {
                    formHelpers.loadFormErrors($form, json.fieldErrors);
                }
            }
        });
    });
};
